import { TableCell } from '@mui/material'

import { HeaderColumnCell } from './HeaderColumnCell'
import { HeaderColumnCellsProps } from './types'

export const HeaderColumnCells = ({
  basePrefix,
  sx,
  verticalHeaderLength,
  verticalHeaders,
}: HeaderColumnCellsProps): React.JSX.Element => {
  const colSpan = (
    labels: string[],
    verticalHeaderLength: number,
    index: number,
  ): number | undefined => {
    const isLastLabel = index === labels.length - 1
    const missingCells: number = verticalHeaderLength - labels.length

    return isLastLabel && missingCells > 0 ? missingCells + 1 : undefined
  }

  return (
    <>
      {verticalHeaders.map(
        (header: string, index: number): React.JSX.Element => (
          <TableCell
            colSpan={colSpan(verticalHeaders, verticalHeaderLength, index)}
            key={header}
            sx={sx}
          >
            <HeaderColumnCell
              basePrefix={basePrefix}
              header={header}
            />
          </TableCell>
        ),
      )}
    </>
  )
}
